import React from "react";
import PropTypes from "prop-types";
import { FOUNDER_IMAGE_URL } from "../../../api-urls";

const ImageModal = ({
  isOpen,
  handleClose,
  bigImage,
  smallImages,
  clickedItem,
  handleImageClick,
  handleNextBig,
  handlePrevBig,
  icons,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 overflow-visible max-h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-tertiary rounded-lg w-full">
        <button
          className="absolute top-5 right-5 text-black h-7 w-7"
          onClick={handleClose}
        >
          <img src={icons.viewClose} alt="close modal" />
        </button>

        <div className="flex flex-col lg:flex-row gap-6 lg:gap-40 xl:gap-60 px-2 lg:px-0 relative left-1 lg:left-40 lg:w-[80%]">
          {/* Small Image Section */}
          <div className="lg:hidden w-full relative">
            <img
              src={FOUNDER_IMAGE_URL + bigImage}
              alt="Big Dress"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex flex-row lg:flex-col gap-4 lg:gap-6 h-24 w-[26%] md:h-40 md:w-[25%] lg:h-auto lg:w-20 xl:w-24 2xl:w-20 relative px-2 py-3">
            {smallImages.map((image, index) => (
              <img
                key={index}
                src={FOUNDER_IMAGE_URL + image}
                alt={`Image ${index + 1}`}
                className="w-full h-[50%]"
                onClick={() => handleImageClick(image, index, clickedItem)}
              />
            ))}
          </div>

          <div className="hidden lg:flex w-[40%] lg:h-[110%]">
            <img
              src={icons.viewLeftArrow}
              alt="left arrow"
              className="relative lg:right-8 top-96 xl:top-[480px] 2xl:top-96 transform -translate-y-1/2 text-primary1 text-lg font-semibold w-10 h-10 rounded-[50%] z-20 bg-tertiary hidden lg:block cursor-pointer"
              onClick={handlePrevBig}
            />
            <img
              src={FOUNDER_IMAGE_URL + bigImage}
              alt="Big Dress"
              className="w-full h-screen object-cover cursor-grab"
            />
            <img
              src={icons.viewRightArrow}
              alt="right arrow"
              className="relative top-96 xl:top-[480px] 2xl:top-96 lg:right-7 xl:left-8 transform -translate-y-1/2 hidden text-primary1 rounded-[50%] bg-tertiary lg:block w-10 h-10 z-10 cursor-pointer"
              onClick={handleNextBig}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ImageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  bigImage: PropTypes.string,
  smallImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  clickedItem: PropTypes.object,
  handleImageClick: PropTypes.func.isRequired,
  handleNextBig: PropTypes.func.isRequired,
  handlePrevBig: PropTypes.func.isRequired,
  icons: PropTypes.object.isRequired,
};

export default ImageModal;
